import { render, staticRenderFns } from "./LoaderShow.vue?vue&type=template&id=2638ba77"
import script from "./LoaderShow.vue?vue&type=script&lang=js"
export * from "./LoaderShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports